"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BPMNBuilder = void 0;
var xmlbuilder2_1 = require("xmlbuilder2");
var BPMNProcessBuilder_1 = require("./BPMNProcessBuilder");
var BPMNBuilder = (function () {
    function BPMNBuilder(process) {
        this._mainNodeName = 'bpmn:definitions';
        this._processNodeName = 'bpmn:process';
        this._error = null;
        this._TESTDIAG = "\n    \n\n    ";
        this._xmlObj = {};
        this.mainNode = {
            '@xmlns:bpmn': 'http://www.omg.org/spec/BPMN/20100524/MODEL',
            '@xmlns:bpmndi': 'http://www.omg.org/spec/BPMN/20100524/DI',
            '@xmlns:dc': 'http://www.omg.org/spec/DD/20100524/DC',
            '@xmlns:di': 'http://www.omg.org/spec/DD/20100524/DI',
            '@xmlns:xsi': 'http://www.w3.org/2001/XMLSchema-instance',
            '@targetNamespace': 'http://bpmn.io/schema/bpmn'
        };
        try {
            var PB = new BPMNProcessBuilder_1.BPMNProcessBuilder(process);
            this._processXML = PB.BPMN.ToObject();
            this.mainNode[this._processNodeName] = this._processXML;
        }
        catch (e) {
            this._error = e.message;
            console.log(e);
        }
    }
    BPMNBuilder.prototype.produceDiagram = function () {
        return __awaiter(this, void 0, void 0, function () {
            var AutoLayout, autoLayout, BPMNComplete, doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AutoLayout = require('bpmn-auto-layout');
                        autoLayout = new AutoLayout();
                        return [4, autoLayout.layoutProcess(this.BPMNWithoutDiagram)];
                    case 1:
                        BPMNComplete = _a.sent();
                        doc = (0, xmlbuilder2_1.create)(BPMNComplete);
                        this._BPMNcomplete = doc.end({ prettyPrint: true });
                        return [2];
                }
            });
        });
    };
    Object.defineProperty(BPMNBuilder.prototype, "BPMNWithoutDiagram", {
        get: function () {
            return this._BPMNWithoutDiagram;
        },
        enumerable: false,
        configurable: true
    });
    BPMNBuilder.prototype.BuildBPMNWithoudDiagram = function () {
        try {
            var doc = (0, xmlbuilder2_1.create)(this._xmlObj);
            this._BPMNWithoutDiagram = doc.end({ prettyPrint: true });
        }
        catch (e) {
            console.log(e);
            this._error = e.message;
            return false;
        }
    };
    Object.defineProperty(BPMNBuilder.prototype, "Error", {
        get: function () { return this._error; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BPMNBuilder.prototype, "mainNode", {
        get: function () { return this._xmlObj[this._mainNodeName]; },
        set: function (node) { this._xmlObj[this._mainNodeName] = node; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BPMNBuilder.prototype, "BPMN", {
        get: function () { return this._BPMNcomplete; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BPMNBuilder.prototype, "GotError", {
        get: function () { return this._error !== null; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BPMNBuilder.prototype, "NoError", {
        get: function () { return !this.GotError; },
        enumerable: false,
        configurable: true
    });
    return BPMNBuilder;
}());
exports.BPMNBuilder = BPMNBuilder;
//# sourceMappingURL=BPMNBuilder.js.map